// extracted by mini-css-extract-plugin
export default {"container":"Pill_container__adHLR"};